import dayjs from "dayjs";

import { ArrowDotRightIcon } from "components/SVGIcons";
import { EQUIPMENT_TYPES } from "constants/signup";
import { formatNumber } from "helpers/formatNumber";
import { IRateTrendResponse } from "models/RateTrend";
import styles from "./style.module.scss";

interface IProps {
  data: IRateTrendResponse;
}

export default function LaneTrendItem({ data }: Readonly<IProps>) {
  const equipmentType = EQUIPMENT_TYPES.find((type) => type.value === data.trailerType)?.label;
  const createdDate = dayjs(data.created).format("MMM DD");

  return (
    <li className={styles.rateTrendLanesBody}>
      <div>
        <div className={styles.rateTrendLanesRow}>
          <span>{data.origin_location}</span>
          <ArrowDotRightIcon className="w-fit" />
          <span>{data.destination_location}</span>
        </div>
        <span className="ml-auto">{data.length} ft</span>
      </div>

      <div>
        <span>{formatNumber(data.amount / 100, 2)}</span>
        <span className="ml-auto">{data.weight} lbs</span>
      </div>

      <div className="text-placeholder">
        <span>{equipmentType}</span>
        <span className="ml-auto">{createdDate}</span>
      </div>
    </li>
  );
}
